import {ApiUtil} from "../apiUtils";
import {Role, User} from "../../model/types/user";
import {PaymentMethodDTO} from "../../model/dto/payment.dto";
import {UserUpdatePaymentMethodPayload} from "../../model/payload/payment.payload";
import {AuthResponseDTO, ChangePasswordAdminDTO, EditPasswordDTO, SignupDTO} from "../../model/dto/auth.dto";
import {Building} from "../../model/types/building";

export class UserController {
    public static baseName = "user"

    public static async add(signupDTO: SignupDTO): Promise<AuthResponseDTO> {
        return await ApiUtil.makeRequest<AuthResponseDTO>(
            "post",
            UserController.baseName+"/add",
            true,
            signupDTO,
        );
    }
    public static async autocomplete(query: string, role: Role): Promise<Array<User>> {
        return await ApiUtil.makeRequest<Array<User>>(
            "post",
            UserController.baseName+"/autocomplete",
            true,
            {query: query, role: role},
        );
    }
    public static async updateStatus(idUser: string, status: number): Promise<User> {
        return await ApiUtil.makeRequest<User>(
            "post",
            UserController.baseName+"/status",
            true,
            {idUser: idUser, status: status},
        );
    }
    public static async editPassword(editPasswordDto: EditPasswordDTO): Promise<User> {
        return await ApiUtil.makeRequest<User>(
            "post",
            UserController.baseName+"/editPassword",
            true,
            editPasswordDto,
        );
    }
    public static async changePasswordAdmin(changePasswordAdminDTO: ChangePasswordAdminDTO): Promise<User> {
        return await ApiUtil.makeRequest<User>(
            "post",
            UserController.baseName+"/changePassword",
            true,
            changePasswordAdminDTO,
        );
    }


    public static async profile(): Promise<User> {
        return await ApiUtil.makeRequest<User>(
            "get",
            UserController.baseName,
            true,
            null,
        );
    }
    //Only for backoffice
    public static async userAll(): Promise<Array<User>> {
        return await ApiUtil.makeRequest<Array<User>>(
            "get",
            UserController.baseName+"/all",
            true,
            null,
        );
    }
    public static async get(id: string): Promise<User> {
        return await ApiUtil.makeRequest<User>(
            "get",
            UserController.baseName+"/"+id,
            true,
            null,
        );
    }
    public static async delete(id: number): Promise<Array<Building>>{
        return await ApiUtil.makeRequest<Array<Building>>("delete",UserController.baseName+"/"+id,true,null,null,null,false)
    }
    public static async paymentMethod(): Promise<PaymentMethodDTO> {
        const resp = await ApiUtil.makeRequest<any>(
            "get",
            UserController.baseName+"/paymentMethod",
            true,
            null,
        );
        if(!resp.result && resp.error){
            console.log("Ritorno null")
            return null
        }
        return resp as PaymentMethodDTO
    }
    public static async paymentSetupIntent(): Promise<{clientSecret: string}> {
        return await ApiUtil.makeRequest<{clientSecret: string}>(
            "get",
            UserController.baseName+"/payment/setupIntent",
            true,
            null,
        );
    }
    public static async updateUser(user: User): Promise<User> {
        return await ApiUtil.makeRequest<User>(
            "post",
            UserController.baseName+"/update",
            true,
            user,
        );
    }
    public static async updatePaymentMethod(userUpdatePaymentMethod: UserUpdatePaymentMethodPayload): Promise<PaymentMethodDTO> {
        return await ApiUtil.makeRequest<PaymentMethodDTO>(
            "post",
            UserController.baseName+"/updatePaymentMethod",
            true,
            userUpdatePaymentMethod,
        );
    }
}
